import React, { useState } from 'react';
import axios from 'axios'
import { getCurrentSession } from "@/endpoints/amplify/auth"; // its from amplify
import { API_PUBLIC_HOST } from '@/_constant/urlconstants';
import Button from '@/_component/Common/button/Button';
import { formatFromISODate } from '@/utility/common-utils';
import { Error, Success } from '@/_service/notification/notification';
import { updatePurchaseRequestAppointmentStatus } from '@/apis';


export default function AppointmentForm({ setAppointmentForm, editObj = {}, editForm = '', listAppointWithMetaData, addAppObj, fetchListLeads, isPurchaseRequestLead = false }){
    
    const [formData, setFormData] = useState({
        name: '',
        date: '',
        time: '',
        location: '',
        typeOfLead: '',
    })

    const [editFormData, setEditFormData] = useState({
        date: formatFromISODate(editObj.appointmentDate, "yyyy-MM-dd"),
        location: editObj.location,
        time: formatFromISODate(editObj.appointmentDate, 'HH:mm:ss'),
    });  

    const onChangeForm = (e) => {
        if(editForm === 'editForm') {
            setEditFormData({ ...editFormData, [e.target.name]: e.target.value })
        } else{
            setFormData({ ...formData, [e.target.name]: e.target.value })
        }
    }

    const handleSubmit = (e) =>{
        e.preventDefault();
        if(editForm === 'editForm'){
            updateAppointment();
            return;
        }
        onSubmitAppoinment();
    }

    const onSubmitAppoinment = (e) => {
        if (!formData.date && !formData.time && !formData.location) {
            Error('Form fields Shoud not be empty');
            return;
        }
        getCurrentSession((success, user, jwtToken) => {
            const url = `${API_PUBLIC_HOST}/lead/addAppointment`;
            


            var data = {
                appointmentDate: `${formData.date}T${formData.time}`,
                "appointmentStatus": "Open",
                // 2023-02-24T08:45:55
                listId: addAppObj.listId,
                appointmentLocation: formData.location,
                buyerId: user.phone_number,
            }
            // console.log(data,'formdata');
            
            axios({
                method: 'post',
                url: url,
                data: data,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: jwtToken,
                },
            })
                .then((response) => {

                    // console.log(isPurchaseRequestLead,'isPurchaseRequestLead',response);
                    // debugger
                    // Success(response.data.message);
                    setAppointmentForm(false);
                    // if(isPurchaseRequestLead){
                    //     updatePurchaseRequestAppointmentStatus(response.data.response.id, "Open")
                    //     .then(res=> {
                    //         if(res.status === 200){
                    //             // Success("Appointment created successfully");
                    //         }
                    //     });
                    // }

                    setTimeout(() => {
                        fetchListLeads();
                    }, 3000);
                    
                })
                .catch((error) => {
                    console.log(error);
                    Error('SomethingWent Wrong !!!')
                });
        })
    }


    const updateAppointment = (e) => {
        let timeAndDate = `${editFormData.date}T${editFormData.time}`
        getCurrentSession((success, jwtToken) => {
            const url = `${API_PUBLIC_HOST}/lead/updateAppointment`;
            var data = {
                appointmentDate: timeAndDate,
                comments: "",
                id: editObj.id,
                location: editFormData.location,
                status: editObj.status,
            }

            axios({
                method: 'post',
                url: url,
                data: data,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: jwtToken,
                },
            })
                .then((response) => {
                    Success(response.data.message);
                    setAppointmentForm(false);
                    setTimeout(() => {
                        listAppointWithMetaData();
                    }, 3000)
                })
                .catch((error) => {
                    console.log(error)
                    Error('SomethingWent Wrong!!!');
                });
        })
    }

    return (
        <div className='px-2 py-2 w-100' style={{zIndex: 999}}>
            <div className='row mb-3'>
              {editForm === 'editForm' && editObj?.typeOfLead && (
                <small>Type of Lead {`>`} {editObj.typeOfLead}</small>
                )}

                {editForm !== 'editForm' && addAppObj?.category && addAppObj?.subCategory && (
                <small>
                    {addAppObj.category} {`>`} {addAppObj.subCategory}
                </small>
                )}
            </div>
            <form className='row align-items-center gy-3' onSubmit={handleSubmit}>
                <div className="col-md-6">
                    <label htmlFor='name' className='form-label'>Name:</label>
                </div>

                <div className='col-md-6'>
                    <input disabled className="form-control mb-0" type='text' id="name" placeholder='Enter Name' name='name' readOnly value={editForm === 'editForm' ? editObj.buyerName : (addAppObj.name || addAppObj.createdUserName)} />
                </div>

                <div className="col-md-6">
                    <label htmlFor='date' className='form-label'>Chooser Date:</label>
                </div>

                <div className='col-md-6'>
                    <input type="date" value={editForm==='editForm' ? editFormData.date : formData.date} onChange={onChangeForm} className="form-control mb-0" name="date" id="date" />
                </div>

                <div className="col-md-6">
                    <label htmlFor='time' className='form-label'>Time:</label>
                </div>

                <div className='col-md-6'>
                    <input type="time" name="time" value={editForm === 'editForm' ? editFormData.time : formData.time } onChange={onChangeForm} id="id" className='form-control mb-0' />
                </div>
                <div className="col-md-6">
                    <label htmlFor='location' className='form-label'>Location:</label>
                </div>

                <div className='col-md-6'>
                    <input className="form-control mb-0" id="location" name='location' type='text' required placeholder='Enter location' value={editForm === 'editForm' ? editFormData.location : formData.location} onChange={onChangeForm} />
                </div>

                <div className='col-12 text-end'>
                    <Button type="submit" primary solid rounded>{editForm === 'editForm' ? "UPDATE" : "SUBMIT"}</Button>
                </div>
            </form>
        </div>
    );
};